import { Injectable } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { CommsService } from '../../services/comms/comms.service';
import { NoteService } from '../../services/note/note.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../display/display.service';
import { UserService } from '../user/user.service';
import _ from 'lodash';

@Injectable()
export class AccountService {

	searchingILC = false;

	constructor(
		private dataService: DataService,
		private commsService: CommsService,
		private noteService: NoteService,
		private configService: ConfigService,
		private displayService: DisplayService,
		private userService: UserService
	) { }

	// DATA INTEGRATIONS
	searchAccounts(account, contractorId, startDate, deepSearch = false) {
		if (deepSearch) {
			this.searchingILC = true;
		}
		const self = this;
		this.commsService.findAccounts(account, contractorId, startDate, deepSearch).subscribe((res) => {
			if (deepSearch) {
				const delay = setTimeout(function(){
					self.searchingILC = false;
				}, 2000);
			}
			const jsonRes = res;
			console.log('SEARCH ACCOUNTS RES: ', jsonRes);
			const successData = jsonRes[self.configService.detailDataProp];
			self.dataService.updateSearchAccounts(successData);
		}, (err) => {
			self.commsService.handleAPIError('Load Account', err);
			if (deepSearch) {
				const delay = setTimeout(function(){
					self.searchingILC = false;
				}, 2000);
			}
		});
	}

	// HELPER METHODS

	getAccountsFromNodes(nodes) {
		const self = this;
		const accounts = [];
		nodes.forEach(function (dd, ii) {
			const accountBlock = self.createAccountBlock(dd);
			accounts.push(accountBlock);
		});
		return accounts;
	}

	createAccountBlock(accountNode) {
		console.log('CREATE ACCOUNT BLOCK: ', accountNode);
		if (accountNode && accountNode.children) {
			const accountBlock = {
				accountid: accountNode.name,
				_id: accountNode._id,
				workitems: []
			};
			if (this.dataService.selectedPO && this.dataService.selectedPO.prop) {
				accountBlock[this.configService.poNumberProp] = this.dataService.selectedPO.prop;
			}
			accountBlock[this.configService.supplierIdProp] = this.userService.supplierId;

			accountNode.children.forEach(function (d, i) {

				const activityCodes = [];

				d.children.forEach(function (dd, ii) {

					const billCodes = [];

					dd.children.forEach(function (ddd, iii) {
						billCodes.push(ddd.name);
					});

					const activityCode = {
						activitycode: dd.name,
						activitydescription: dd.description,
						billcodes: billCodes
					};

					activityCodes.push(activityCode);
				});


				const workItem = {

					workitemid: d.name,
					groupid: d.description,
					activitycodes: activityCodes
				};

				accountBlock.workitems.push(workItem);

			});
			return accountBlock;
		}
	}

	nodesFromAccounts(accounts) {

		const nodes = [];

		try {
			if (accounts !== null) {

				accounts.forEach(function (d, i) {

					// console.log('ACCOUNT: ', d);

					const workItems = [];

					if (d.workitems !== undefined) {

						d.workitems.forEach(function (dd, ii) {

							const activityCodes = [];

							if (dd.activitycodes !== undefined) {

								dd.activitycodes.forEach(function (ddd, iii) {

									const billCodes = [];

									if (ddd.billcodes !== undefined) {

										ddd.billcodes.forEach(function (dddd, iiii) {

											const billCode = {
												id: dddd,
												name: dddd
											};

											billCodes.push(billCode);

										});

									}

									const activityCode = {
										id: 'AC-' + ddd.activitycode,
										name: ddd.activitycode,
										description: ddd.activitydescription,
										children: billCodes
									};

									activityCodes.push(activityCode);

								});

							}

							const workItem = {
								id: 'WI-' + dd.workitemid,
								name: dd.workitemid,
								description: dd.groupid ? dd.groupid : '',
								children: activityCodes
							};

							workItems.push(workItem);
						});

					}

					if (workItems.length === 0) {
						workItems.push({
							id: '',
							name: '',
							description: ''
						});
					}

					const account = {
						id: 'ID-' + d.accountid,
						name: d.accountid,
						children: workItems,
						_id: d._id
					};

					nodes.push(account);
				});

			} else {

				console.log('NO ACCOUNTS');

			}
		} catch (e) {

			console.log('NO ACCOUNTS');

		}

		// console.log('TREE NODES: ', nodes);
		return nodes;
	}

	isDefaultOption(accountId) {
		let isDefaultOption = false;

		// Check to see if a default option is selected
		// this.configService.defaultTimeTypes.forEach(function (d, i) {
		// 	if (accountId === d) {
		// 		isDefaultOption = true;
		// 	}
		// });
		this.configService.defaultOptions.forEach(function(d, i){
			if (accountId === d.value ) {
				isDefaultOption = true;
			}
		});
		return isDefaultOption;
	}

	getWorkitemOptions(accountId) {

		// Check to see if a default option is selected
		const isDefaultOption = this.isDefaultOption(accountId);

		// If actual account is selected get the related work items
		// If not, return null so other dropdowns can be hidden
		if (!isDefaultOption) {
			const options = [];
			try {
				const account = _.cloneDeep(this.dataService.accounts).filter(function (obj) {
					return obj['accountid'] === accountId;
				});
				// console.log('GET WORK ITEM OPTIONS', id, this.dataService.accounts, account);
				account[0]['workitems'].forEach(element => {
					if (element.groupid) {
						// console.log('CODE HAS DESCRIPTION');
						options.push(element.workitemid + ' : ' + element.groupid);
						// console.log('OPTIONS: ', options);
					} else {
						options.push(element.workitemid);
					}
				});
				// console.log('WORK ITEM OPTIONS', options);
			} catch (e) { }
			return options;
		} else {
			return null;
		}
	}

	getActivitycodeOptions(accountId, workitemId) {
		if (workitemId.indexOf(':') > 0) {
			workitemId = workitemId.split(' : ', 1)[0];
		}
		const options = [];
		try {
			const account = _.cloneDeep(this.dataService.accounts).filter(function (obj) {
				return obj['accountid'] === accountId;
			});
			const workitems = account[0]['workitems'].filter(function (obj) {
				return obj['workitemid'] === workitemId;
			});
			// console.log('GET ACTIVITY CODE OPTIONS', account, workitems, accountId, workitemId);
			workitems[0]['activitycodes'].forEach(element => {
				if (element.activitydescription) {
					// console.log('CODE HAS DESCRIPTION');
					options.push(element.activitycode + ' : ' + element.activitydescription);
					// console.log('OPTIONS: ', options);
				} else {
					// console.log('NO CODE DESCRIPTION');
					options.push(element.activitycode);
					// console.log('OPTIONS: ', options);
				}
			});
		} catch (e) { }
		return options;
	}

	getBillcodeOptions(accountId, workitemId, activityId) {
		const options = [];
		if (workitemId.indexOf(':') > 0) {
			workitemId = workitemId.split(' : ', 1)[0];
		}
		try {
			const account = _.cloneDeep(this.dataService.accounts).filter(function (obj) {
				return obj['accountid'] === accountId;
			});
			// console.log('GET BILLCODE OPTIONS: ', accountId, workitemId, activityId, account);
			const workitems = account[0]['workitems'].filter(function (obj) {
				return obj['workitemid'] === workitemId;
			});
			const activitycodes = workitems[0]['activitycodes'].filter(function (obj) {
				// return obj['activitycode'] == activityID;
				// console.log('BILLCODES ACTIVITY: ', activityID, activityID.split(' : ', 1)[0]);

				return obj['activitycode'] === activityId.split(' : ', 1)[0];
			});
			activitycodes[0]['billcodes'].forEach(element => {
				options.push(element);
			});
		} catch (e) { }
		return options;
	}
}
